var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/SolutionsMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { t } from '@sm/intl';
import NavSubmenuCopy from '../../copy/NavSubmenuCopy';
import Menu from './components/Menu.js';
import SubMenu from './components/SubMenu';
import SubMenuBody from './components/SubMenuBody.js';
import ByNeedSubMenu from './components/ByNeedSubMenu.js';
import BottomLinkWrapper from './components/BottomLinkWrapper.js';
import SubMenuItem from './components/SubMenuItem.js';
import Column from './components/Column.js';
import SurveyTypesColumn from './components/SurveyTypesColumn.js';
import ByNeedColumn from './components/ByNeedColumn.js';
import BottomLink from './components/BottomLink.js';
import Block from './components/Block.js';
import ColumnTitle from './components/ColumnTitle.js';
import SolutionByNeed from './components/SolutionByNeed.js';
import SurveySolution from './components/SurveySolution.js';
import { exploreSurveyTypes, peoplePoweredData, customerFeedback, employeeFeedback, marketResearch, solutionsForTeams, customerExperience, humanResources, marketing, customerSatisfaction, customerLoyalty, eventSurveys, employeeEngagement, jobSatisfaction, hrSurveys, marketResearchSurveys, opinionPolls, conceptTesting, solutionsMenu } from '../../config/linkInfo';
import SMHeaderContext from '../../SMHeaderContext';
export var SolutionsMenu = function SolutionsMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  var key = 'Solutions';
  var subMenuTitle = t(NavSubmenuCopy.SOLUTIONS_TITLE);
  return /*#__PURE__*/React.createElement(Menu, Object.assign({
    menuKey: key
  }, solutionsMenu(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SubMenu, {
    submenuKey: key,
    title: subMenuTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SubMenuBody, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }, lang === 'en' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SurveyTypesColumn, {
    title: "Survey Types",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Block, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, customerSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, customerLoyalty(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, eventSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 19
    }
  }))), /*#__PURE__*/React.createElement(Block, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, employeeEngagement(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, jobSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, hrSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 19
    }
  }))), /*#__PURE__*/React.createElement(Block, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, marketResearchSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, opinionPolls(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 19
    }
  })), /*#__PURE__*/React.createElement(SurveySolution, Object.assign({}, conceptTesting(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 19
    }
  })))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, peoplePoweredData(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, customerFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, employeeFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, marketResearch(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, solutionsForTeams(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, customerExperience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, humanResources(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, marketing(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 17
    }
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, customerFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, employeeFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, marketResearch(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 17
    }
  }))))), lang !== 'en' ? /*#__PURE__*/React.createElement(ByNeedSubMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ByNeedColumn, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, customerSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, customerLoyalty(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, eventSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(ByNeedColumn, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, employeeEngagement(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, jobSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, hrSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(ByNeedColumn, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, marketResearchSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, opinionPolls(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, conceptTesting(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 15
    }
  })))) : null, /*#__PURE__*/React.createElement(BottomLinkWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(BottomLink, Object.assign({}, exploreSurveyTypes(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 11
    }
  })))));
};
export default SolutionsMenu;
//# sourceMappingURL=SolutionsMenu.js.map